import styled from "styled-components";
import { Panel, hudScrollName } from "../../ui";

export const HUDContainer = styled.div`
  position: absolute;
  top: 1rem;
  right: 1rem;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.4rem;
  pointer-events: none;
  z-index: 1010;
`;

export const HealthBar = styled.div`
  ${({ $pct, theme }) => `
    height: 8px;
    background: linear-gradient(90deg,
      ${$pct > 50 ? theme.colors("success") : $pct > 25 ? theme.colors("warning") : theme.colors("danger")} ${$pct}%,
      ${theme.colors("foreground", 0.15)} ${$pct}%
    );
    border: 1px solid ${theme.colors("foreground", 0.2)};
    margin-top: 2px;
  `}
`;

export const ToggleButton = styled.button`
  background: ${({ theme }) => theme.colors("background", 0.85)};
  border: 1px solid
    ${({ $open, theme }) =>
      $open ? theme.colors("link") : theme.colors("link", 0.5)};
  color: ${({ $open, theme }) =>
    $open ? theme.colors("text") : theme.colors("foreground", 0.45)};
  font-family: 'Silkscreen', monospace;
  font-size: 0.65rem;
  padding: 0.4rem 0.75rem;
  cursor: pointer;
  text-align: left;
  pointer-events: auto;
  ${({ $fullWidth }) => $fullWidth ? "width: 100%;" : "width: 10rem;"}
  &:hover {
    border-color: ${({ theme }) => theme.colors("highlight")};
    color: ${({ theme }) => theme.colors("text")};
  }
  &:hover .hud-scroll-name.is-scrollable {
    animation: ${hudScrollName} 3s ease-in-out infinite;
  }
`;

export const PriceTag = styled.span`
  font-size: 0.55rem;
  color: ${({ theme }) => theme.colors("highlight")};
  flex-shrink: 0;
`;

export const StatusToast = styled(Panel)`
  position: fixed;
  top: 1rem;
  left: 50%;
  transform: translateX(-50%);
  min-width: unset;
  pointer-events: none;
  z-index: 20000;
  white-space: nowrap;
`;

export const ChatContainer = styled.div`
  position: absolute;
  bottom: calc(3.5rem + env(safe-area-inset-bottom, 0px) + 0.5rem);
  left: 1rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0;
  pointer-events: auto;
  z-index: 10000;
  width: 280px;
`;

export const ChatPanel = styled.div`
  width: 100%;
  background: ${({ theme }) => theme.colors("background", 0.88)};
  border: 1px solid ${({ theme }) => theme.colors("foreground", 0.2)};
  border-bottom: none;
  display: flex;
  flex-direction: column;
  max-height: 220px;
`;

export const ChatMessages = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 0.4rem 0.6rem;
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  font-family: 'Silkscreen', monospace;
  font-size: 0.6rem;
`;

export const ChatMsg = styled.div`
  color: ${({ theme }) => theme.colors("text")};
  line-height: 1.4;
  word-break: break-word;
`;

export const ChatAuthor = styled.span`
  color: ${({ theme }) => theme.colors("highlight")};
  margin-right: 0.35rem;
`;

export const ChatInputRow = styled.div`
  display: flex;
  border-top: 1px solid ${({ theme }) => theme.colors("foreground", 0.12)};
`;

export const ChatInput = styled.input`
  flex: 1;
  background: none;
  border: none;
  outline: none;
  color: ${({ theme }) => theme.colors("text")};
  font-family: 'Silkscreen', monospace;
  font-size: 0.6rem;
  padding: 0.35rem 0.6rem;
`;

export const ChatSend = styled.button`
  background: none;
  border: none;
  border-left: 1px solid ${({ theme }) => theme.colors("foreground", 0.12)};
  color: ${({ theme }) => theme.colors("link")};
  font-family: 'Silkscreen', monospace;
  font-size: 0.6rem;
  padding: 0.35rem 0.6rem;
  cursor: pointer;
  flex-shrink: 0;
  &:hover {
    color: ${({ theme }) => theme.colors("highlight")};
  }
`;
